// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.designs-container[data-v-1c64d73a] {\r\n    margin: 0px 100px 0px 100px;\n}\n.designs[data-v-1c64d73a] {\r\n    font-size: 0px;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    text-align: center;\r\n    white-space: nowrap;\n}\r\n", ""]);
// Exports
module.exports = exports;
